import { render, staticRenderFns } from "./PopularDownloadItem.vue?vue&type=template&id=05c0e3e9&scoped=true&"
import script from "./PopularDownloadItem.vue?vue&type=script&lang=js&"
export * from "./PopularDownloadItem.vue?vue&type=script&lang=js&"
import style0 from "./PopularDownloadItem.vue?vue&type=style&index=0&id=05c0e3e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c0e3e9",
  null
  
)

export default component.exports